export default "__VITE_ASSET__439ed8c7__"